import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: '2.375rem',
    margin: 0,
    '@media (max-width: 50rem)': {
      fontSize: '2rem',
      textAlign: 'center'
    }
  },
  paragraph: {
    fontSize: '1.125rem',
    letterSpacing: '0.2px',
    lineHeight: 1.5
  },
  boldParagraph: {
    fontWeight: 600,
    '@media (max-width: 50rem)': {
      textAlign: 'center'
    }
  },
  image: {
    width: '100%'
  },
  desktopOnly: {
    '@media (max-width: 50rem)': {
      display: 'none'
    }
  }
}));

export default { useStyles };
